const ValueLabel = ({label, value, labelWidth}) => {
  return <div className="flex mb-3">
    <div className={`${labelWidth ? labelWidth : "w-44"} font-medium`}>{label}</div>
    <div className="flex-1">{value}</div>
  </div>
}


export default ValueLabel